export default __webpack_public_path__ + "static/media/dana-regular.aba1631b.woff";